import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";
import styled from "styled-components";

const TableContainer = styled.div`
  .ant-table-thead > tr > th,
  .ant-table-thead > tr > td {
    position: relative;
    color: ${(props) => props.color || theme.colors.black};
    font-weight: bold !important;
    text-align: start;
    background: ${(props) => props.backgroundColor || theme.colors.white};
    border-bottom: 2px solid #f0f0f0;
    transition: background 0.2s ease;
    padding: ${(props) => props.padding || "8px 10px"};
  }
  .ant-table-thead > tr {
    border-left: 2px solid red;
  }
  .ant-table-filter-trigger {
    color: black;
    font-size: 10px !important;
    opacity: 0.8;
  }

  .ant-table-container table > thead > tr:first-child > *:first-child {
    border-start-start-radius: 3px;
  }

  .ant-table-container table > thead > tr:first-child > *:last-child {
    border-start-end-radius: 3px;
  }

  .ant-table-cell,
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > th,
  .ant-table-tbody > tr > td,
  tfoot > tr > th,
  tfoot > tr > td {
    position: relative;
    padding: ${(props) => props.padding || "8px 10px"};
    overflow-wrap: break-word;
    border-inline-end: none !important;
  }

  .ant-table-column-sorter {
    margin-inline-start: 4px;
    color: black;
    font-size: 5px;
    opacity: 0.8;
  }

  .ant-table-column-sorters:hover .ant-table-column-sorter {
    color: black !important;
  }

  .ant-table-thead th.ant-table-column-has-sorters:hover {
    background: white !important;
  }

  a:where(.css-dev-only-do-not-override-17seli4).ant-typography,
  :where(.css-dev-only-do-not-override-17seli4).ant-typography a {
    color: ${theme.colors.white};
    text-decoration: none;
    outline: none;
    cursor: pointer;
    transition: color 0.3s;
  }

  .ant-table {
    line-height: 1 !important;
    font-size: 12px !important;
  }

  .ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
    background: ${(props) =>
      props.backgroundColor || theme.colors.white} !important;
  }
  .ant-btn {
    padding: 0px;
  }
  .ant-table-container {
    border: none !important;
  }
  .ant-table-column-sorter-up {
    font-size: 10px !important;
  }
  .ant-table-column-sorter-down {
    font-size: 10px !important;
  }

  .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
    background-color: #fef4f0;
  }
  .ant-table-tbody .ant-table-row:hover > .ant-table-cell:first-child {
    border-left: ${(props) =>
      props.borderleft || `4px solid ${theme.colors.themeColor} !important`};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${theme.colors.themeColor};
    border-color: ${theme.colors.themeColor};
  }
  .ant-checkbox-checked:hover {
    background-color: ${theme.colors.themeColor};
    border-color: ${theme.colors.themeColor};
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border-color: ${theme.colors.themeColor} !important;
  }

  .ant-checkbox-checked:hover .ant-checkbox-inner {
    background-color: ${theme.colors.themeColor}!important;
    border-color: ${theme.colors.themeColor}!important;
  }
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 350px;
  margin-bottom: 10px;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #888;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
`;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;

const SC = {
  TableContainer,
  InputStyle,
  InputContiner,
  SearchIcon,
  HeadingTag,
};

export default SC;
